import api from '../../../services/api';

export const getLeadExecutions = async () => {
  const response = await api.get('/lead-executions');
  return response.data;
};

export const getLeadExecutionById = async (id) => {
  const response = await api.get(`/lead-executions/${id}`);
  return response.data.data;
};

export const updateLeadExecutionStage = async (id, status) => {
  const response = await api.put(`/lead-executions/${id}/stage`, { status });
  return response.data;
};

export const updateLeadExecutionSiteExc = async (leadId, siteExecutive) => {
  const response = await api.put(`/verve-contacts/${leadId}`, { siteExecutive });
  return response.data;
};

export const updateLeadExecutionProjectValue = async (id, projectValue) => {
  const response = await api.put(`/lead-executions/${id}/project-value`, { projectValue });
  return response.data;
};

export const assignTeamMembers = async (id, fieldOfficers) => {
  const response = await api.put(`/lead-executions/${id}/team`, { fieldOfficers });
  return response.data;
};

export const postTradeWorkUpdate = async (id, formData) => {
  // Using api instance with appropriate headers for FormData
  const response = await api.post(`/lead-executions/${id}/work-updates`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};
